var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:_vm.num>0.25?'blue':'red'},[_c('div',{class:_vm.num>=0.5?'two':'two lightBlue'},[_c('div',{class:_vm.num>=0.75?'three':'three lightBlue'},[_c('div',{class:_vm.num>=1?'four':'four lightBlue'})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }